import { useState } from "react";
import { Seo } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { IMG } from "@/constants/images";

const FILTERS = ["All", "Homes", "Kitchens", "Dining Tables", "Sofas", "Hotels", "Offices"];
const PROJECTS = [
  ["Luxury Villa", "New Delhi", "Homes", IMG.hero], ["Modern Apartment", "Gurugram", "Homes", IMG.sofa],
  ["Marble Kitchen", "Noida", "Kitchens", IMG.kitchen], ["Dining Suite", "Delhi", "Dining Tables", IMG.diningTable],
  ["5 Star Hotel", "Mumbai", "Hotels", IMG.proj3], ["Corporate Office", "Bangalore", "Offices", IMG.proj2],
  ["Designer Sofa Set", "Pune", "Sofas", IMG.velvetSofa], ["Penthouse Residence", "Gurugram", "Homes", IMG.proj4],
  ["Boutique Restaurant", "Hyderabad", "Hotels", IMG.furniture],
];

export default function Projects() {
  const [f, setF] = useState("All");
  const shown = f === "All" ? PROJECTS : PROJECTS.filter((p) => p[2] === f);
  return (
    <div className="max-w-[1500px] mx-auto px-5 lg:px-10 py-14" data-testid="projects-page">
      <Seo title="Projects" description="ERRAH surface protection projects across luxury homes, hotels, restaurants and offices." />
      <p className="errah-label mb-3">Portfolio</p>
      <h1 className="serif-head text-4xl lg:text-6xl">Beautiful spaces, protected.</h1>
      <div className="mt-8 flex flex-wrap gap-2">
        {FILTERS.map((x) => (
          <button key={x} onClick={() => setF(x)} data-testid={`proj-filter-${x}`}
            className={`px-4 py-2 text-sm border transition-colors ${f === x ? "bg-[#C9A45C] text-black border-[#C9A45C]" : "border-white/15 text-gray-300 hover:border-[#C9A45C]/60"}`}>{x}</button>
        ))}
      </div>
      <div className="mt-8 columns-1 sm:columns-2 lg:columns-3 gap-3.5 [column-fill:_balance]">
        {shown.map(([name, loc, cat, img], i) => (
          <Reveal key={name + i} delay={(i % 3) * 0.05}>
            <div className={`group hover-zoom relative overflow-hidden hair-border mb-3.5 ${i % 3 === 0 ? "aspect-[3/4]" : "aspect-[4/3]"}`}>
              <img src={img} alt={name} loading="lazy" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-transparent to-transparent opacity-80" />
              <div className="absolute bottom-0 p-4">
                <span className="errah-label text-[10px]">{cat}</span>
                <h3 className="font-serif text-xl leading-tight">{name}</h3>
                <p className="text-xs text-gray-400">{loc}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
